import React, { useState, useEffect } from "react";
import DialogModal from "../../../DialogModal";
import Input from "../../../Input";

export default function RenamePaletteDialog({
  open,
  onClose,
  onConfirm,
  initialValue = "",
  title = "Rename Palette",
  message = "Enter a new name for this palette"
}) {
  const [editableTitle, setEditableTitle] = useState(initialValue);

  useEffect(() => {
    setEditableTitle(initialValue);
  }, [initialValue, open]);

  const handleTitleChange = (e) => {
    setEditableTitle(e.target.value);
  };

  const handleConfirm = () => {
    if (editableTitle.trim() === "") {
      return;
    }
    onConfirm(editableTitle.trim());
  };

  const handleCancel = () => {
    setEditableTitle(initialValue); // Reset to original name
    onClose();
  };

  return (
    <DialogModal
      open={open}
      onClose={handleCancel}
      title={title}
      message={message}
      extraText={
        <Input
          value={editableTitle}
          onChange={handleTitleChange}
          placeholder="Palette name"
          containerStyle={{
            width: 300,
            marginBottom: 0,
          }}
        />
      }
      primaryButton="Confirm"
      secondaryButton="Cancel"
      onPrimaryPress={handleConfirm}
      onSecondaryPress={handleCancel}
      modalStyle={{
        width: 520,
        minWidth: 520,
      }}
    />
  );
} 